export const CHOOSE_ROOM = "Choose Room";
export const CHOOSE_DATES = "Choose Dates";
